'use strict';

angular.module('theme').service('AddressService', function ($q, $http) {

	this.check = function (ssn) {
		return $http({
			url: '/backapi/address',
			method: 'POST',
			headers: {
				Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvd3d3Lm1hdGtvbWZvcnQuc2UiLCJhdWQiOiJodHRwczpcL1wvd3d3Lm1hdGtvbWZvcnQuc2UifQ.2wy91AFWfkhCVRGf3j0aPEL067RwsxkCvf-TyrHjbUY'
			},
			data: {
				socialSecurityNumber: ssn
			}
		}).then(function (response) {
			console.log('address', response.data);
			return response.data;
		});
	};

});
